import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { CreateSIEFileButtonProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { StyledButton } from "components/common";
import useSIEFileUploadDialog from "./forms/useSIEUploadDialog";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CreateSIEFileButton: React.FC<CreateSIEFileButtonProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const uploadSIEFileDialog = useSIEFileUploadDialog(props.onCreateSuccess);

  const onUploadButtonClick = async () => {
    dispatch(displayDialog(uploadSIEFileDialog));
  };

  return (
    <StyledButton size="sm" onClick={onUploadButtonClick}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.UploadSIEFile)}
    </StyledButton>
  );
};

export default CreateSIEFileButton;
